<template>
  <div>
    <!-- NAV -->
    <div class="d-flex align-items-stretch pb-7" style="min-height: calc(100vh - 110px)">
      <!-- Sidebar -->
      <nav v-if="currentpage !== 'login'" id="myaccount-sidebar" class="nav flex-column nav-pills">
        <div style="padding: 1rem">
          <div style="font-size: larger">{{ printLang('MyAccount.Title') }}</div>
        </div>
        <a :href="`${baseUrl}#profile`" :class="{ active: currentpage == 'profile' }" class="nav-link">
          <i class="fas fa-user mr-2"></i>
          {{ printLang('MyAccount.Profile.Title') }}
        </a>
        <a :href="`${baseUrl}#company`" :class="{ active: currentpage == 'company' || currentpage == 'no-company' }" class="nav-link">
          <i class="fas fa-building mr-2"></i>
          {{ printLang('MyAccount.Company.Title') }}
        </a>
        <a :href="`${baseUrl}#premium`" :class="{ active: currentpage == 'premium' || currentpage == 'checkout' }" class="nav-link">
          <i class="fas fa-star mr-2"></i>
          {{ printLang('MyAccount.Menu.Premium') }}
        </a>
        <a href class="nav-link mt-auto text-center" @click.prevent="logout('./')">
          <i class="fas fa-sign-out-alt mr-1"></i>
          {{ printLang('MyAccount.Menu.LogOut') }}
        </a>
      </nav>
      <div id="myaccount-content" class="flex-grow-1" :style="currentpage == 'login' ? 'margin-left: 0px;' : ''">
        <!-- MOBILE NAVBAR -->
        <nav v-if="currentpage !== 'login'" id="myaccount-mobile-navbar" class="nav nav-pills">
          <a :href="`${baseUrl}#profile`" :class="{ active: currentpage == 'profile' }" class="nav-link">
            <i class="fas fa-user"></i>
            <div>{{ printLang('MyAccount.Menu.Profile') }}</div>
          </a>
          <a :href="`${baseUrl}#company`" :class="{ active: currentpage == 'company' || currentpage == 'no-company' }" class="nav-link">
            <i class="fas fa-building"></i>
            <div>{{ printLang('MyAccount.Menu.Company') }}</div>
          </a>
          <a :href="`${baseUrl}#premium`" :class="{ active: currentpage == 'premium' || currentpage == 'checkout' }" class="nav-link">
            <i class="fas fa-star"></i>
            <div>{{ printLang('MyAccount.Menu.Premium') }}</div>
          </a>
          <a href class="nav-link d-none d-sm-block" @click.prevent="logout('./')">
            <i class="fas fa-sign-out-alt"></i>
            <div>{{ printLang('MyAccount.Menu.LogOut') }}</div>
          </a>
        </nav>
        <div class="mt-4 px-6" style="font-size: 16px;">
          <div v-if="pageTitle" class="mb-5" style="font-size: x-large; font-weight: bold;">{{ pageTitle }}</div>
          <my-account-profile v-if="currentpage == 'profile'" :currentpage="currentpage" @show-page="showPage($event)"></my-account-profile>
          <my-account-company v-if="currentpage == 'company'" :currentpage="currentpage" @show-page="showPage($event)"></my-account-company>
          <my-account-no-company v-if="currentpage == 'no-company'" :currentpage="currentpage" @show-page="showPage($event)"></my-account-no-company>
          <my-account-premium v-if="currentpage == 'premium'" :coupon="checkout.coupon" @set-coupon="checkout.coupon = $event">
          </my-account-premium>
          <my-account-checkout v-if="currentpage == 'checkout'" :currentpage="currentpage" :plan="checkout.plan" :users="checkout.users" :coupon="checkout.coupon">
          </my-account-checkout>
          <my-account-login v-if="currentpage == 'login'" :currentpage="currentpage"></my-account-login>

          <!-- PAGE : LOGOUT-->
          <div v-if="currentpage == 'logout'" class="page logout">
            <h4>{{ printLang('MyAccount.LogOut.LoggingOut') }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  /* TRANSITIONS : fade, slide-fade */
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  .slide-fade-enter-active {
    transition: all 0.6s ease;
  }
  .slide-fade-enter {
    transform: translateX(10px);
    opacity: 0;
  }

  /* SIDEBAR */
  #myaccount-sidebar {
    display: none;
    width: 200px;
    flex: 0 0 200px;
  }
  #myaccount-sidebar .nav-link {
    padding-top: .7rem;
    padding-bottom: .7rem;
  }
  #myaccount-sidebar .nav-link.active {
    color: #0169c1;
  }

  @media (min-width: 768px) {
    #myaccount-sidebar {
      display: flex !important;
    }
  }

  /* MOBILE NAVBAR */
  #myaccount-mobile-navbar .nav-link {
    text-align: center;
    line-height: 1.5;
    padding-top: .4rem;
    padding-bottom: .4rem;
    flex: 1 1 0px;
  }
  #myaccount-mobile-navbar .nav-link.active {
    color: #0169c1;
  }

  @media (min-width: 768px) {
    #myaccount-mobile-navbar {
      display: none !important;
    }
  }
</style>

<script>
  import { printLang } from './lang';
  import MyAccountProfile from './MyAccountProfile.vue';
  import MyAccountCompany from './MyAccountCompany.vue';
  import MyAccountNoCompany from './MyAccountNoCompany.vue';
  import MyAccountPremium from './MyAccountPremium/Premium.vue';
  import MyAccountCheckout from './MyAccountCheckout.vue';
  import MyAccountLogin from './MyAccountLogin.vue';

  export default {
    components: {
      MyAccountProfile,
      MyAccountCompany,
      MyAccountNoCompany,
      MyAccountPremium,
      MyAccountCheckout,
      MyAccountLogin,
    },
    data() {
      return {
        currentpage: 'profile',
        printLang,
        checkout: {
          plan: '',
          users: 1,
          coupon: '',
        },
      };
    },
    computed: {
      pageTitle() {
        switch (this.currentpage) {
        case 'profile':
          return ''; // printLang('MyAccount.Profile.Title');
        case 'company':
          return ''; // printLang('MyAccount.Company.Title');
        case 'no-company':
          return printLang('MyAccount.NoCompany.Title');
        case 'logout':
          return printLang('MyAccount.Logout.Title');
        case 'premium':
          return ''; // printLang('MyAccount.Premium.Title');
        case 'checkout':
          return (this.checkout.plan || '').toUpperCase() == 'NEWCARD' ? printLang('MyAccount.Checkout.TitleNewCard') : printLang('MyAccount.Checkout.Title');
        case 'login':
          return printLang('MyAccount.Login.Title');
        default:
          return "";
        }
      },
      baseUrl() { return printLang('Url'); },
    },
    created() {
      // Default inputs
      document.addEventListener("DOMContentLoaded", () => {
        if (sessionStorage.user_email) $(".contactform [name=email]").val(sessionStorage.user_email);
      });
    },
    mounted() {
      // INIT
      this.init();
      window.onhashchange = this.init;
    },
    methods: {
      init() {
        /* Read search params from url */
        const searchParams = {};
        const searchVars = window.location.search.substring(1).split('&');
        for (let i = 0; i < searchVars.length; i++) {
          const pair = searchVars[i].split('=');
          searchParams[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
        if (searchParams.plan) this.checkout.plan = searchParams.plan;
        if (searchParams.users) this.checkout.users = parseInt(searchParams.users, 10);
        if (searchParams.coupon) this.checkout.coupon = searchParams.coupon;

        /* Read hash for tab */
        const tab = window.location.hash ? (window.location.hash).substr(1) : 'profile';
        this.showPage(tab);
      },
      showPage(page) {
        this.currentpage = page;
      },
      logout(redirect) {
        this.currentpage = 'logout';
        window.logout(redirect);
      },
    },
  };
</script>
